import React from 'react';
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { formatTime, useIsMobileDimensions, useShouldFloatToolbar } from '../../shared/utils';
import { PuzzleNames, PuzzleNamesForUI } from '../../../../utils/types';
import DesktopToolbar from './DesktopToolbar';
import { ArchiveMorphologyStore } from '../ArchiveMorphologyStore';
import { saveMorphology } from '../archiveMorphologyUtils';
import Instructions from './Instructions';
import '../../shared/PuzzleTopBar/PuzzleTopBar.less';

const MorphologyTopBar = () => {
  const { completed, time, isPaused } = ArchiveMorphologyStore.useState();

  const useFloatingToolbar = useShouldFloatToolbar(105);
  const useMobileStyles = isMobile || useIsMobileDimensions();
  const navigate = useNavigate();

  const pauseButtonClass = completed ? 'hidden' : '';

  return (
    <div className={`puzzleTopBar ${useMobileStyles ? 'mobile' : ''}`}>
      <div className="topBarLeftSection">
        <IconButton disableRipple title="Back" onClick={() => {
          navigate('/');
          window.scrollTo(0, 0);
          saveMorphology();
        }}>
          <KeyboardBackspaceIcon/>
        </IconButton>
        <div className="navigationLabel">{PuzzleNamesForUI[PuzzleNames.Morphology]}</div>
      </div>

      <div className="topBarMiddleSection">
        <div className="timer">{formatTime(time)}</div>
        <IconButton className={pauseButtonClass} title="Pause" onClick={() => {
          ArchiveMorphologyStore.update(s => {
            if (!s.isPaused) {
              saveMorphology();
            }
            s.isPaused = !s.isPaused;
          });
          window.scrollTo(0, 0);
        }}>
          {isPaused ? <PlayArrowIcon/> : <PauseIcon/>}
        </IconButton>
      </div>

      <div className="topBarRightSection">
        <Instructions/>

        {useFloatingToolbar && <DesktopToolbar/>}

        <IconButton disableRipple title="How to Play" onClick={() => {
          ArchiveMorphologyStore.update(s => {
            s.instructionsAreOpen = true;
            s.isSoftPaused = true;
          });
        }}>
          <HelpOutlineIcon/>
        </IconButton>
      </div>
    </div>
  );
};

export default MorphologyTopBar;